module.exports = __webpack_public_path__ + "static/media/minus-icon.284848d6.svg";